import React from 'react'
import PropTypes from 'prop-types'
import { Iso147322013, Iso960612013, Asme92017 } from './standards'

const standardComponents = {
  'iso960612013': Iso960612013,
  'iso147322013': Iso147322013,
  'asme92017': Asme92017,
}

const propTypes = {
  standard: PropTypes.object,
  values: PropTypes.object,
  dictionaries: PropTypes.object,
  validationErrors: PropTypes.object,
  handleSelectChange: PropTypes.func.isRequired,
}

const StandardForm = ({ standard = {}, values, dictionaries, validationErrors = {}, handleSelectChange }) => {
  const StandardComponent = standardComponents[standard.slug]

  return (
    <React.Fragment>
      {StandardComponent && <StandardComponent
        values={values}
        dictionaries={dictionaries}
        validationErrors={validationErrors}
        handleSelectChange={handleSelectChange}
      />}
    </React.Fragment>
  )
}

StandardForm.propTypes = propTypes

export default StandardForm



// WEBPACK FOOTER //
// ./src/components/Welders/forms/StandardForm.js